import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GroupsListingModel } from 'common/models/page-models/groups/groups-grid-model';
import { GroupsModel } from 'common/models/page-models/groups/groups-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { GroupsGridWidgetService } from 'common/widget/groups/groups-grid-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class GroupsGridResolver extends GridResolver<GroupsModel, GroupsListingModel> {
    constructor(
        protected fs: GroupsGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}